import { queryOptions } from '@tanstack/react-query';
import {
  helpdeskAiContentApi,
  type HelpdeskAiContentKind,
  type AiContentListQuery,
} from '@shared/api';
export const aiContentKeys = {
  options: (scope: string, kind: HelpdeskAiContentKind) =>
    ['helpdesk-ai-content', scope, kind, 'form-options'] as const,
  lists: (scope: string, kind: HelpdeskAiContentKind) =>
    ['helpdesk-ai-content', scope, kind, 'list'] as const,
  detail: (scope: string, kind: HelpdeskAiContentKind, id: string) =>
    ['helpdesk-ai-content', scope, kind, 'detail', id] as const,
};
export const aiContentFormOptionsQuery = (scope: string, kind: HelpdeskAiContentKind) =>
  queryOptions({
    queryKey: aiContentKeys.options(scope, kind),
    queryFn: ({ signal }) => helpdeskAiContentApi.formOptions(kind, signal),
    retry: false,
    staleTime: 0,
  });
export const aiContentListQuery = (
  scope: string,
  kind: HelpdeskAiContentKind,
  params: AiContentListQuery
) =>
  queryOptions({
    queryKey: [...aiContentKeys.lists(scope, kind), params],
    queryFn: ({ signal }) => helpdeskAiContentApi.list(kind, params, signal),
    refetchInterval: (query) =>
      !query.state.error &&
      query.state.data?.items.some(
        (row) => row.creation?.state === 'pending' || row.deletion?.state === 'pending'
      )
        ? 2000
        : false,
    placeholderData: (previousData, previousQuery) =>
      scope.length > 0 &&
      previousQuery?.queryKey[0] === 'helpdesk-ai-content' &&
      previousQuery.queryKey[1] === scope &&
      previousQuery.queryKey[2] === kind &&
      previousQuery.queryKey[3] === 'list'
        ? previousData
        : undefined,
    retry: false,
    staleTime: 0,
  });
export const aiContentDetailQuery = (scope: string, kind: HelpdeskAiContentKind, id: string) =>
  queryOptions({
    queryKey: aiContentKeys.detail(scope, kind, id),
    queryFn: ({ signal }) => helpdeskAiContentApi.detail(kind, id, signal),
    refetchInterval: (query) =>
      !query.state.error &&
      (query.state.data?.data.creation?.state === 'pending' ||
        query.state.data?.data.deletion?.state === 'pending')
        ? 2000
        : false,
    retry: false,
    staleTime: 0,
  });
